import React from "react";
import HomeHeader from "./home/Layout/HomeHeader";
import maintenanceImg from "../pics/maintenanceImge.png";

const MaintenancePage = () => {
  return (
    <div className="min-h-screen  flex flex-col">
      {/* Header */}
      <HomeHeader BackGroundColor="transparent" />

      {/* Main Content */}
      <div className="flex-1 flex items-center justify-center px-6">
        <div className="max-w-6xl mx-auto grid lg:grid-cols-3 gap-12 items-center">
          {/* Left Side - Illustration */}
          <div className=" col-span-1   ">
            <img src={maintenanceImg} alt="" />
          </div>

          {/* Right Side - Content */}
          <div className=" col-span-2 text-center lg:text-left space-y-6  max-w-[640px] mx-auto ">
            <h1 className="font-bold text-[35px] leading-[100%] tracking-[0%] text-white ">
              Hold tight, we're cooking!
            </h1>

            <div className="text-white font-normal text-[35px] leading-[100%] tracking-[0%] space-y-4">
              <p>
                SPONSA is currently down for maintenance but will be back
                shortly! If you have any questions, please contact us at{" "}
                <a
                  href="mailto:support@sponsa.app"
                  className="text-white hover:text-cyan-300 transition-colors hover:underline"
                >
                  support@sponsa.app
                </a>{" "}
                and we'll be happy to help!
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer spacing */}
      <div className="h-16"></div>
    </div>
  );
};

export default MaintenancePage;
